<template>
  <v-dialog v-model="$parent.isRegister" persistent width="500" style="direction: rtl;">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">הרשמה למערכת</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right>
          סוג חשבון
        </v-flex>
        <v-flex xs8>
          <span class="custom-dropdown custom-dropdown--white">
            <select v-model="Type" class="custom-dropdown__select custom-dropdown__select--white">
              <option value="">בחר סוג חשבון</option>
              <option v-for="type in userTypes" :value="type">{{type}}</option>
            </select>
          </span>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right>
          שם מלא
        </v-flex>
        <v-flex xs8>
          <input type="text" v-model="FullName" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right>
          תעודת זהות
        </v-flex>
        <v-flex xs8>
          <input type="text" v-model="Identity" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;" v-show="isCustomer">
        <v-flex xs4 right>
          איש קשר
        </v-flex>
        <v-flex xs8>
          <input type="text" v-model="ContactPerson" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;" v-show="isCustomer">
        <v-flex xs4 right>
          טלפון
        </v-flex>
        <v-flex xs8>
          <input type="text" v-model="Phone" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right>
          שם משתמש (אימייל)
        </v-flex>
        <v-flex xs8>
          <input type="text" v-model="Username" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right>
          סיסמה<br /> (לפחות 6 אותיות/מספרים)
        </v-flex>
        <v-flex xs8>
          <input type="password" v-model="Password" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right>
          אימות סיסמה
        </v-flex>
        <v-flex xs8>
          <input type="password" v-model="PasswordConfirm" />
        </v-flex>
      </v-layout>
      <v-flex row wrap style="padding: 10px 10px 10px 10px;">
        <span class="error" v-show="error">* {{error}}</span>
      </v-flex>
      <v-layout row wrap style="padding: 20px;">
        <v-flex xs6 style="padding: 20px;">
          <input type="button" class="btnPopupYes" value="שמירה" @click="signup" />
        </v-flex>
        <v-flex xs6 style="padding: 20px;">
          <input type="button" class="btnPopupNo" value="ביטול" @click="cancel" />
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
  import { db, auth } from '../firebase';
  var usersRef = db.ref('Users');

  export default {
    name: 'PopupRegister',
    data() {
      return {
        selectedType: "",
        userTypes: ['רוכש', 'מנהל עבודה', 'מפקח', 'משקיף'],
        error: '',
        FullName: '',
        Username: '',
        ContactPerson: '',
        Phone: '',
        Identity: '',
        Type: '',
        Password: '',
        PasswordConfirm: ''
      }
    },
    created() {
      this.$Log("Vue [PopupRegister] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupRegister] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupRegister] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupRegister] is updated ...");
    },
    computed: {
      isCustomer() {
        return this.selectedType == 'רוכש';
      }
    },
    methods: {
      isValid() {
        if (this.FullName.trim().length <= 0) { this.error = "נא הכנס שם מלא!"; return false; }
        if (this.Username.trim().length <= 0) { this.error = "נא הכנס שם משתמש!"; return false; }
        if (this.Identity.trim().length <= 0) { this.error = "נא הכנס שם תעודת זהות!"; return false; }
        if (this.Type.trim().length <= 0) { this.error = "נא בחר סוג חשבון!"; return false; }
        if (this.Password.trim().length <= 0) { this.error = "נא הכנס שם סיסמה!"; return false; }
        if (this.Password.trim() != this.PasswordConfirm.trim()) { this.error = "אימות סיסמה נכשל!"; return false; }
        return true;
      },
      signup() {
        var vm = this;
        if (vm.isValid()) {
          var user = {
            FullName: vm.FullName, //auth.currentUser.displayName,
            Username: vm.Username.toLowerCase(),
            Identity: vm.Identity,
            Type: vm.Type,
            Password: vm.Password,
            TotalDiaries: 0,
            UsedDiaries: 0,
            MessagesCounter: 0,
            ContactPerson: '',
            Active: true,
            Approved: false
          };

          usersRef.orderByChild("Username").equalTo(vm.Username.toLowerCase()).once('value').then(function (snapshot) {
            var obj = snapshot.val();
            if (obj) {
              vm.error = "שם משתמש קיים במערכת! נא לבחור שם משתמש אחר!";
            }
            else {
              usersRef.push(user);
              vm.reset();
            }
          });
          //var usersRef = db.ref('Users/' + userId);
          
        }
        else {
          alert(vm.error)
        }
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        this.$parent.isRegister = false;
      }
    }
  }

</script>
<style>
  .error {
    color: red;
    background-color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// PopupRegister.vue?374fc5c2